import { ADMIN, ifyouApi } from 'apis/config';
import ErrorMessage from 'apis/ErrorMessage';

export const exchangeApis = {
  read: () =>
    ifyouApi
      .get(`${ADMIN}/exchange-list`)
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  update: (rows) =>
    ifyouApi
      .post(`${ADMIN}/exchange-update`, { rows: rows })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
};

export const exchangeDelete = async (productId) => {
  try {
    const res = await ifyouApi.post(`${ADMIN}/exchange-delete`, {
      exchange_product_id: productId,
    });
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};
